module.exports = __webpack_public_path__ + "img/default-avatar.ad910542.jpg";